<div class="variants-inline">

  <!-- Linked variants list -->
  <div *ngIf="variants && variants.length > 0" class="variants-list p-mb-3">
    <div
      *ngFor="let v of variants; let i = index"
      class="variant-row"
    >
      <a [href]="v.id ? '/variants/' + v.id : null" target="_blank" rel="noopener noreferrer" class="variant-name-link" (click)="$event.stopPropagation()">
        {{ getVariantName(v) || v._id }}<span *ngIf="v.id"> ({{ v.id }})</span>
      </a>
      <p-button
        icon="pi pi-times"
        styleClass="p-button-text p-button-danger p-button-sm remove-btn"
        (onClick)="removeVariant(i)"
      ></p-button>
    </div>
  </div>
  <p *ngIf="!variants || variants.length === 0" class="p-text-secondary p-mb-3" style="font-size:0.875rem;">
    No variants added yet.
  </p>

  <!-- Search & add existing variant -->
  <div class="p-d-flex p-ai-center p-mb-3" style="gap: 0.75rem;">
    <p-autoComplete
      [(ngModel)]="searchQuery"
      [suggestions]="searchResults"
      (completeMethod)="searchVariants($event)"
      (onSelect)="addExistingVariant($event)"
      [field]="'name'"
      placeholder="Search existing variants..."
      [style]="{'width': '280px'}"
      [inputStyle]="{'width': '100%'}"
      appendTo="body"
    >
      <ng-template let-v pTemplate="item">
        <span>{{ getVariantName(v) }}<span *ngIf="v.id" style="color:#868e96; margin-left:0.4rem;">({{ v.id }})</span></span>
      </ng-template>
    </p-autoComplete>

    <p-button
      [label]="showForm ? 'Cancel' : '+ Add Variant'"
      [icon]="showForm ? 'pi pi-times' : ''"
      [styleClass]="showForm ? 'p-button-outlined p-button-secondary p-button-sm' : 'p-button-outlined p-button-sm'"
      (onClick)="toggleForm()"
    ></p-button>
  </div>

  <!-- Inline create form -->
  <div *ngIf="showForm" class="variant-create-panel p-mt-3">
    <p-divider></p-divider>

    <div class="p-fluid p-formgrid p-grid">

      <div class="p-field p-col-12 p-md-6">
        <label class="field-label">Name <span class="required">*</span></label>
        <input
          pInputText
          [(ngModel)]="newVariant.name"
          placeholder="e.g. Red, Large, Shiny..."
        />
      </div>

      <div class="p-field p-col-12 p-md-3 p-d-flex p-ai-end">
        <p-toggleButton
          [(ngModel)]="newVariant.enabled"
          onLabel="Enabled"
          offLabel="Not Enabled"
          onIcon="pi pi-check"
          offIcon="pi pi-times"
          [style]="{'width': '100%'}"
        ></p-toggleButton>
      </div>

      <div class="p-field p-col-12 p-md-3 p-d-flex p-ai-end">
        <p-multiSelect
          [(ngModel)]="newVariant.env"
          [options]="envOptions"
          optionLabel="label"
          optionValue="value"
          display="chip"
          placeholder="Environments"
          [style]="{'width': '100%'}"
        ></p-multiSelect>
      </div>

    </div>

    <small *ngIf="errorMessage" class="p-error" style="display:block; margin-bottom: 0.5rem;">
      {{ errorMessage }}
    </small>

    <p-button
      label="Create Variant"
      icon="pi pi-check"
      styleClass="p-button-sm"
      [loading]="isCreating"
      [disabled]="isCreating || !newVariant.name"
      (onClick)="createVariant()"
    ></p-button>
  </div>

</div>
